import { render } from "./LinkedinIcon.vue?vue&type=template&id=c2f80c5c"
const script = {}
script.render = render

export default script